<div class="flex flex-col gap-2">
    <div class="font-bold sm:pt-0 text-ponder-light">
        <span class="text-base">Add New Set</span>
    </div>
    <div class="flex flex-col bg-slate-100 rounded shadow min-w-64">
        <form [formGroup]="createSetForm" class="flex flex-col gap-1 p-2 bg-slate-50 rounded-t">
            <div class="flex flex-row gap-2 items-center">
                <div class="w-[12ch] text-right">Name:</div>
                <input formControlName="name" class="p-[5px] rounded-sm shadow-sm bg-white w-[48ch]" placeholder="Required">
            </div>
            <div class="flex flex-row gap-2 items-center">
                <div class="w-[12ch] text-right">Code:</div>
                <input formControlName="code" class="p-[5px] rounded-sm shadow-sm bg-white w-[48ch]" placeholder="Required">
            </div>
            <div class="flex flex-row gap-2 items-center">
                <div class="w-[12ch] text-right">Released:</div>
                <input formControlName="released" type="date" class="p-[5px] rounded-sm shadow-sm bg-white w-[48ch]" placeholder="Required">
            </div>
            <div class="flex flex-row gap-2 items-center">
                <div class="w-[12ch] text-right">Type:</div>
                <input formControlName="type" class="p-[5px] rounded-sm shadow-sm bg-white w-[48ch]" placeholder="Required">
            </div>
            <div class="flex flex-row gap-2 items-center">
                <div class="w-[12ch] text-right">Parent Set:</div>
                <input formControlName="parentSet" class="p-[5px] rounded-sm shadow-sm bg-white w-[48ch]">
            </div>
            <div class="flex flex-row gap-2 items-center">
                <div class="w-[12ch] text-right">Parent Block:</div>
                <input formControlName="parentBlock" class="p-[5px] rounded-sm shadow-sm bg-white w-[48ch]">
            </div>
            <div class="flex flex-row gap-2 items-center" title="Contains cards from products outside of the Magic setting. Such as: Lord of the Rings, Warhammer, DND, Marvel, etc.">
                <div class="flex flex-row justify-end w-[12ch]">
                    <input formControlName="universesBeyond" type="checkbox">
                </div>
                <div>Universes Beyond</div>
            </div>
        </form>
        <div class="flex flex-row gap-2 p-2 border-t items-center justify-end">
            @if (!savingSuccess) {
                <div class="text-red-600">
                    Uh oh! Something went wrong ...
                </div>
            }
            <button 
                (click)="onSaveClicked()" 
                class="p-1 rounded-sm shadow-sm w-[10ch] bg-white border border-opacity-0 border-ponder-link hover:border-opacity-100 hover:text-ponder-link disabled:text-slate-400 disabled:hover:border-opacity-0"
                [disabled]="isSaving || !createSetForm.valid">
                @if (!isSaving) {
                    Create
                } @else {
                    <busy-spin class="p-1"></busy-spin>
                }
            </button>
        </div>
    </div>
</div>